export interface CountryOption {
  name: string;
  isoCode: string;
}

// ISO 3166-1 alpha-2 codes, used with getFlagEmoji() to render flag emojis without image assets.
export const COUNTRIES: CountryOption[] = [
  { name: 'Afghanistan', isoCode: 'AF' },
  { name: 'Albania', isoCode: 'AL' },
  { name: 'Algeria', isoCode: 'DZ' },
  { name: 'Argentina', isoCode: 'AR' },
  { name: 'Armenia', isoCode: 'AM' },
  { name: 'Australia', isoCode: 'AU' },
  { name: 'Austria', isoCode: 'AT' },
  { name: 'Azerbaijan', isoCode: 'AZ' },
  { name: 'Belgium', isoCode: 'BE' },
  { name: 'Bolivia', isoCode: 'BO' },
  { name: 'Bosnia and Herzegovina', isoCode: 'BA' },
  { name: 'Brazil', isoCode: 'BR' },
  { name: 'Bulgaria', isoCode: 'BG' },
  { name: 'Cameroon', isoCode: 'CM' },
  { name: 'Canada', isoCode: 'CA' },
  { name: 'Chile', isoCode: 'CL' },
  { name: 'China', isoCode: 'CN' },
  { name: 'Colombia', isoCode: 'CO' },
  { name: 'Costa Rica', isoCode: 'CR' },
  { name: 'Croatia', isoCode: 'HR' },
  { name: 'Cyprus', isoCode: 'CY' },
  { name: 'Czech Republic', isoCode: 'CZ' },
  { name: 'Denmark', isoCode: 'DK' },
  { name: 'Ecuador', isoCode: 'EC' },
  { name: 'Egypt', isoCode: 'EG' },
  { name: 'Estonia', isoCode: 'EE' },
  { name: 'Finland', isoCode: 'FI' },
  { name: 'France', isoCode: 'FR' },
  { name: 'Georgia', isoCode: 'GE' },
  { name: 'Germany', isoCode: 'DE' },
  { name: 'Ghana', isoCode: 'GH' },
  { name: 'Greece', isoCode: 'GR' },
  { name: 'Hungary', isoCode: 'HU' },
  { name: 'Iceland', isoCode: 'IS' },
  { name: 'India', isoCode: 'IN' },
  { name: 'Indonesia', isoCode: 'ID' },
  { name: 'Iran', isoCode: 'IR' },
  { name: 'Iraq', isoCode: 'IQ' },
  { name: 'Ireland', isoCode: 'IE' },
  { name: 'Israel', isoCode: 'IL' },
  { name: 'Italy', isoCode: 'IT' },
  { name: 'Ivory Coast', isoCode: 'CI' },
  { name: 'Japan', isoCode: 'JP' },
  { name: 'Jordan', isoCode: 'JO' },
  { name: 'Kazakhstan', isoCode: 'KZ' },
  { name: 'Kenya', isoCode: 'KE' },
  { name: 'Kuwait', isoCode: 'KW' },
  { name: 'Latvia', isoCode: 'LV' },
  { name: 'Lebanon', isoCode: 'LB' },
  { name: 'Libya', isoCode: 'LY' },
  { name: 'Lithuania', isoCode: 'LT' },
  { name: 'Luxembourg', isoCode: 'LU' },
  { name: 'Malaysia', isoCode: 'MY' },
  { name: 'Mali', isoCode: 'ML' },
  { name: 'Malta', isoCode: 'MT' },
  { name: 'Mexico', isoCode: 'MX' },
  { name: 'Monaco', isoCode: 'MC' },
  { name: 'Montenegro', isoCode: 'ME' },
  { name: 'Morocco', isoCode: 'MA' },
  { name: 'Netherlands', isoCode: 'NL' },
  { name: 'New Zealand', isoCode: 'NZ' },
  { name: 'Nigeria', isoCode: 'NG' },
  { name: 'North Macedonia', isoCode: 'MK' },
  { name: 'Norway', isoCode: 'NO' },
  { name: 'Oman', isoCode: 'OM' },
  { name: 'Pakistan', isoCode: 'PK' },
  { name: 'Panama', isoCode: 'PA' },
  { name: 'Paraguay', isoCode: 'PY' },
  { name: 'Peru', isoCode: 'PE' },
  { name: 'Philippines', isoCode: 'PH' },
  { name: 'Poland', isoCode: 'PL' },
  { name: 'Portugal', isoCode: 'PT' },
  { name: 'Qatar', isoCode: 'QA' },
  { name: 'Romania', isoCode: 'RO' },
  { name: 'Russia', isoCode: 'RU' },
  { name: 'Saudi Arabia', isoCode: 'SA' },
  { name: 'Senegal', isoCode: 'SN' },
  { name: 'Serbia', isoCode: 'RS' },
  { name: 'Slovakia', isoCode: 'SK' },
  { name: 'Slovenia', isoCode: 'SI' },
  { name: 'South Africa', isoCode: 'ZA' },
  { name: 'South Korea', isoCode: 'KR' },
  { name: 'Spain', isoCode: 'ES' },
  { name: 'Sweden', isoCode: 'SE' },
  { name: 'Switzerland', isoCode: 'CH' },
  { name: 'Tunisia', isoCode: 'TN' },
  { name: 'Turkey', isoCode: 'TR' },
  { name: 'Ukraine', isoCode: 'UA' },
  { name: 'United Arab Emirates', isoCode: 'AE' },
  { name: 'United Kingdom', isoCode: 'GB' },
  { name: 'United States', isoCode: 'US' },
  { name: 'Uruguay', isoCode: 'UY' },
  { name: 'Venezuela', isoCode: 'VE' },
  { name: 'Vietnam', isoCode: 'VN' },
  { name: 'Rest of the World', isoCode: 'ROW' },
];
